/** Raios do handoff — usar nas páginas via import (não dependem do modo) */
export const RADIUS = {
  control: 12, // inputs e botões
  card: 16,
  modal: 20,
  pill: 100,
} as const;

const shape = {
  borderRadius: RADIUS.control,
  // chaves legadas usadas por overrides antigos
  borderRadiusSm: 12,
  borderRadiusMd: RADIUS.card,
};

export default shape;
